import {
  FETCH_SERVICES_DELETION_LOGS_REQUEST,
  FETCH_SERVICES_DELETION_LOGS_SUCCESS,
  FETCH_SERVICES_DELETION_LOGS_FAILURE,
} from "./actionTypes";

export const fetchServicesDeletionLogsRequest = () => ({
  type: FETCH_SERVICES_DELETION_LOGS_REQUEST,
});

export const fetchServicesDeletionLogsSuccess = (logs) => ({
  type: FETCH_SERVICES_DELETION_LOGS_SUCCESS,
  payload: logs,
});

export const fetchServicesDeletionLogsFailure = (error) => ({
  type: FETCH_SERVICES_DELETION_LOGS_FAILURE,
  payload: error,
});